import React from "react";

const ShownProductContext = React.createContext({
    shownProduct: null,
    showProduct: () => {}
})
export default ShownProductContext;